import {FC, lazy, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {DashboardWrapper} from '../pages/supervisor-dashboard/DashboardWrapper'
import StudentsMarksPage from '../pages/supervisor-dashboard/marks/StudentsMarksPage'

const SupervisorRoutes = () => {
  const StudentsPage = lazy(() => import('../pages/supervisor-dashboard/students/StudentsPage'))
  // const StudentsMarksPage = lazy(
  //   () => import('../pages/supervisor-dashboard/marks/StudentsMarksPage')
  // )
  const ProfilePage = lazy(() => import('../pages/supervisor-dashboard/profile/ProfilePage'))
  const FeedbackPage = lazy(() => import('../pages/supervisor-dashboard/feedbacks/FeedbackPage'))
  const ReaderPage = lazy(() => import('../pages/supervisor-dashboard/reader/ReaderPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route
          path='feedbacks/*'
          element={
            <SuspensedView>
              <FeedbackPage />
            </SuspensedView>
          }
        />
        <Route
          path='students/*'
          element={
            <SuspensedView>
              <StudentsPage />
            </SuspensedView>
          }
        />
        <Route
          path='marks/*'
          element={
            <SuspensedView>
              <StudentsMarksPage />
            </SuspensedView>
          }
        />
        <Route
          path='reader/*'
          element={
            <SuspensedView>
              <ReaderPage />
            </SuspensedView>
          }
        />
        <Route
          path='profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {SupervisorRoutes}
